import { vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33dcf1f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-input" }
const _hoisted_2 = { class: "app-input__inner-wrapper inner-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "app-input__error-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
        class: _normalizeClass(["inner-wrapper__input", { 'is-filled': _ctx.inputValue || _ctx.alwaysShowPlaceholder }]),
        type: "text"
      }, null, 2), [
        [_vModelText, _ctx.inputValue]
      ]),
      _createElementVNode("span", {
        class: _normalizeClass(["inner-wrapper__text-placeholder", { 'is-required': _ctx.required }])
      }, _toDisplayString(_ctx.placeholder), 3)
    ]),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true)
  ]))
}